import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { Table } from 'widgets/player-awards-tracker/js/components/Leaderboard/components/table/components/Table';
import { Loader } from 'common/react/components/Loader';
import { EmptyState } from 'common/react/components/EmptyState';
import { TooltipContent } from 'widgets/player-awards-tracker/js/components/Tooltip';
import { setFavouritePlayer } from 'common/store/modules/player-awards/leaderboard';

import { useBrownlowPredictorData } from '../hooks/use-brownlow-predictor-data';

export const PredictorCurrentRoundContext = createContext('');

export const BrownlowPredictor = ({ seasonId }) => {
    const dispatch = useDispatch();
    const {
        isLoading,
        isLoadingSearch,
        noDataAvailable,
        rowData,
        columns,
        favourites,
        sortByFavourites,
        setSortByFavourites,
        isFetching,
        hideLoadMoreBtn,
        fetchMoreData,
        seasonPrId,
        shouldShowBettingOdds,
        leaderboardFilter,
        leaderboardData,
        currentRoundNumber
    } = useBrownlowPredictorData(seasonId);

    const onPlayerFavouriteClick = (playerId) => {
        dispatch(
            setFavouritePlayer({
                id: null,
                providerId: playerId
            })
        );
    };

    if (isLoading || isLoadingSearch || isFetching) {
        return (
            <div className="career-and-season-stats__loader">
                <Loader />
            </div>
        );
    }

    if (noDataAvailable) {
        return (
            <div className="career-and-season-stats__empty-state">
                <EmptyState
                    titleTranslation="label.brownlow.tracker.error.noDataAvailable"
                    summaryTranslation="label.brownlow.tracker.error.noDataAvailable.summary"
                />
            </div>
        );
    }

    return (
        <PredictorCurrentRoundContext.Provider value={currentRoundNumber}>
            {rowData?.length ? (
                <Table
                    columns={columns}
                    data={rowData}
                    fullData={rowData}
                    modifier={`player-awards-tracker-leaderboard brownlow-leaderboard stats-table--brownlow-predictor ${
                        shouldShowBettingOdds
                            ? 'stats-table--player-awards-tracker-leaderboard--show-odds'
                            : ''
                    }`}
                    update={fetchMoreData}
                    key={rowData[0]?.player.playerId}
                    seasonPid={seasonPrId}
                    favourites={favourites}
                    sortByFavourites={sortByFavourites}
                    setSortByFavourites={setSortByFavourites}
                    onPlayerFavouriteClick={onPlayerFavouriteClick}
                    filteredResults={leaderboardFilter?.query?.length > 0}
                    isBrownlowV2
                    isFetching={isFetching}
                    hideLoadMoreBtn={hideLoadMoreBtn}
                    shouldShowBettingOdds={shouldShowBettingOdds}
                    primaryTooltipComponent={(row, cell) => (
                        <TooltipContent
                            row={row.original}
                            cell={cell}
                            player={row.original?.player.playerId}
                            seasonPid={seasonPrId}
                            leaderboardData={leaderboardData}
                            isPredictor
                        />
                    )}
                    status={leaderboardData?.status ?? null}
                />
            ) : null}
        </PredictorCurrentRoundContext.Provider>
    );
};

BrownlowPredictor.propTypes = {
    seasonId: PropTypes.string.isRequired
};
